module.exports = new __parcel__URL__("49c5f3e1-5867-4b1d-a843-2d07fa60d85d.d2184b60.woff2").toString();